import '../css/trust.scss';

import { Icon } from '@iconify/react';


const Trust = () => (
  <div className="trust">

    <div className="content-width">
      <h1>Pourquoi me faire confiance ?</h1>
      <div className="trust-boxes">
        <div className="trust-box flex3">
          <span className="icon user" />
          <h2>Confiance</h2>
          <p>Je suis une personne de confiance. Je respecte mes clients et ne m’immisce pas dans leur vie privée. Je suis, par ailleurs, toujours à l’écoute pour vous procurer des conseils ou simplement pour discuter.</p>
        </div>
        <div className="trust-box flex3">
        <Icon icon="mdi:watch" width="50" height="50" />
        {/* <span className="icon watch" /> */}
          <h2>Ponctualité</h2>
          <p>Etre à l’heure est une valeur primordiale pour moi. Je respecte scrupuleusement les heures et les délais fixés.</p>
        </div>
        <div className="trust-box flex3">
        <span className="icon smile" />
          <h2>Sourire et sympathie</h2>
          <p>Je suis agréable à vivre et de nature souriante. Je réponds à vos questions et essaye de vous apporter de la bonne humeur durant toute la durée du voyage en ma compagnie.</p>
        </div>
        <div className="trust-box flex2">
        <span className="icon car" />
          <h2>Expérience</h2>
          <p>Je suis un conducteur expérimenté. Je conduis depuis de nombreuses années et possède une licence en tant que « taxi collectif (TC) » et une autre en tant que « location de voiture avec chauffeur (LVC) ».</p>
        </div>
        <div className="trust-box flex2">
        <span className="icon clock" />
          <h2>Disponibilité</h2>
          <p>Je suis disponible 24h/24 et 7j/7. Des déplacements sont possibles en cas d’urgence.</p>
        </div>
      </div>
    </div>
  </div>
);

export default Trust;
